function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialFlickr = function SvgSocialFlickr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    }
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17.9 8.95a8.975 8.975 0 0 1-.688 3.488 9.607 9.607 0 0 1-1.951 2.823 9.607 9.607 0 0 1-2.823 1.951 8.975 8.975 0 0 1-3.488.688c-1.254 0-2.417-.229-3.488-.688a9.43 9.43 0 0 1-2.869-1.951 8.924 8.924 0 0 1-1.905-2.823A8.975 8.975 0 0 1 0 8.95c0-1.224.229-2.387.688-3.488a8.924 8.924 0 0 1 1.905-2.823A9.43 9.43 0 0 1 5.462.688C6.533.229 7.696 0 8.95 0c1.224 0 2.387.229 3.488.688a9.607 9.607 0 0 1 2.823 1.951 9.607 9.607 0 0 1 1.951 2.823A8.975 8.975 0 0 1 17.9 8.95Zm21.205 0a8.975 8.975 0 0 1-.688 3.488 8.924 8.924 0 0 1-1.905 2.823 9.438 9.438 0 0 1-2.868 1.951 8.983 8.983 0 0 1-3.489.688 8.978 8.978 0 0 1-3.488-.688 9.607 9.607 0 0 1-2.823-1.951 9.585 9.585 0 0 1-1.95-2.823 8.975 8.975 0 0 1-.689-3.488c0-1.224.23-2.387.689-3.488a9.585 9.585 0 0 1 1.95-2.823A9.607 9.607 0 0 1 26.667.688 8.978 8.978 0 0 1 30.155 0c1.224 0 2.387.229 3.489.688a9.438 9.438 0 0 1 2.868 1.951 8.924 8.924 0 0 1 1.905 2.823 8.975 8.975 0 0 1 .688 3.488Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "matrix(.61373 0 0 .61373 0 7)"
  }));
};
export default SvgSocialFlickr;